import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const RssFeedIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.36 17.82C8.36 19.024 7.384 20 6.18 20S4 19.024 4 17.82C4 16.616 4.976 15.64 6.18 15.64S8.36 16.616 8.36 17.82ZM4 4.44L4 7.27C11.03 7.27 16.73 12.97 16.73 20L19.56 20C19.56 11.41 12.59 4.44 4 4.44ZM4 10.1L4 12.93C7.9 12.93 11.07 16.1 11.07 20L13.9 20C13.9 14.53 9.47 10.1 4 10.1Z"
      fill="currentColor"
    />
  </svg>
);

RssFeedIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(RssFeedIcon);
